import React from 'react';
import PropTypes from "prop-types";
import "./AlertBar.css";

export class AlertBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        let alert = Object.assign(this.props.alert);
        alert.show = false;
        alert.type = "";
        this.props.onClick(alert);
    }

    render() {
        return (
            <div>
                {this.props.alert && this.props.alert.show ?
                    <div className={"alert alert-" + this.props.alert.type} role="alert">
                        {this.props.alert.dismissible ?
                            <button type="button" className="alert-close" onClick={this.handleClick}
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button> : null}
                        <strong>{this.props.alert.title}</strong><span>{this.props.alert.text}</span>
                    </div>
                    : null}
            </div>
        );
    }
}
AlertBar.propTypes = {
    alert: PropTypes.shape({
        type: PropTypes.string.isRequired,
        title: PropTypes.string,
        text: PropTypes.string.isRequired,
        dismissible: PropTypes.bool,
        show: PropTypes.bool.isRequired
    }).isRequired,
    onClick: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/alert/Alerts.js